const nav = {
    "nav.Home": "Home",
    "nav.Test": "Test",
    "nav.gettingStarted": "Getting Started",
};

export default nav;